<template>
    <div class='archive-template'>
      <div class="form-list">
          <div class="tools-bar">
              <div class="tools-search" @keyup.enter="handleSearch">
                   <el-input style="width:260px" maxlength="100" v-model.trim="searchName" placeholder="名称">
                      <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                  </el-input>
                  <el-button  icon="el-icon-view"  title="预览" @click="handleViewTemplate" circle></el-button>
                  <template v-if="isChooseFile" >
                    <!-- <el-button icon="el-icon-view" size="mini" type="primary"  @click="handleShareInnerBatch(1)" plain>共享</el-button>
                    <el-button icon="el-icon-view" size="mini" type="primary"  @click="handleShareInnerBatch(0)" plain>取消共享</el-button> -->
                    <el-button icon="el-icon-delete" size="mini" type="primary" @click="handleDeleteBatch" plain>删除</el-button>
                    <el-button icon="el-icon-d-arrow-right" size="mini" type="primary"  @click="handleMove" plain>移动到</el-button>
                    <!-- <el-button icon="el-icon-download" size="mini" type="primary" disabled @click="handleDownLoadBatch" plain>下载</el-button> -->
                    <!-- <el-button icon="el-icon-edit" size="mini" type="primary" disabled @click="handleRename" plain>重命名</el-button>
                    <el-button icon="el-icon-share" size="mini" type="primary" disabled @click="handleShareOuter" plain>分享</el-button>
                    <el-button icon="el-icon-tickets" size="mini" type="primary" disabled @click="handleCopy" plain>复制到</el-button> -->
                  </template>
              </div>
              <div class="tools-btn-group">
                  <el-button  v-if="!isInstance" icon="el-icon-circle-plus" type="success" size="mini" @click="handleOpenFolder('')" plain>新建文件夹</el-button>
                  <ProcessFiles v-if="isInstance" style="float: right;margin-left: 8px;" bizType="archiveInstance" :treeId="treeId" :treeName="treeName" :processInstanceId="processInstanceId" :templateId="templateId" @getFileList="_getFormData"/>
              </div>
          </div>
          <div class="archiveTemplate">  
             <span class="show-file-info">
              已全部加载，共{{fileListLength}}个
              </span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <transition-group name="breadcrumb">
                  <el-breadcrumb-item v-for="(item,index) in directoryList" :key="item.key">
                      <span v-if="item.key==='-1'"><font color='green'>{{item.meta.title}}</font></span>
                      <span v-else-if="item.path===''">{{item.meta.title}}</span>
                      <router-link v-else :to="item.path" @click.native="handleBreadcrumb(item,index)">{{item.meta.title}}</router-link>
                  </el-breadcrumb-item>
              </transition-group>
          </el-breadcrumb>
          </div>
          <!-- style="width: 100%;height:450px"  -->
          <el-table :key="loadTimer" :data="formList" style="width: 100%;" :border="true" max-height="500"  :default-sort = "{prop: 'orderNum',order: 'ascending'}"  @selection-change="handleSelectionChange" v-loading="loading" >
              <el-table-column type="selection" width="40"> </el-table-column>
              <!-- <el-table-column prop="orderNum" sortable label="序号" width="80" :formatter="getOrderNum"> -->
              <el-table-column prop="orderNum" sortable label="序号" width="80" >
                <!-- <template slot-scope="scope"> 
                   {{getOrderNum(scope.row.orderNum) }} 
                </template> -->
              </el-table-column>
              <el-table-column prop="fileName" label="名称" width="300" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div  v-if="scope.row.category===1" >
                    <el-button icon="el-icon-message" plain @click.stop="handleEnterFolder(scope.row)">{{scope.row.fileName}}</el-button>
                  </div>
                  <div v-else style="cursor:pointer;" @click.stop="handlePreview(scope.row)">
                    <span><a href="#">{{scope.row.fileName}}</a></span>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="fileByteSize" label="大小" width="100">
                  <template slot-scope="scope">
                    <div  v-if="scope.row.category===1" >
                      -
                  </div>
                  <div v-else >
                    {{scope.row.fileByteSize | getfilesize }}
                  </div>
                </template>
              </el-table-column> -->
              <!-- <el-table-column prop="shareStatus" label="状态" width="100" >
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.shareStatus === 0" >未共享</el-tag>
                    <el-tag type="success" v-if="scope.row.shareStatus === 1" >已共享</el-tag>
                  </template>
              </el-table-column> -->
              <el-table-column prop="remarks" label="备注说明" :show-overflow-tooltip="true" width="250"></el-table-column>
              <el-table-column prop="isNeed" label="是否需要" width="80" >
                  <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.need">应</el-tag>
                    <el-tag v-else>宜</el-tag>
                  </template>
              </el-table-column> 
              <el-table-column prop="original" label="原件" width="60" >
                  <template slot-scope="scope">
                    <template v-if="scope.row.original">✔</template>
                    <template v-else></template>
                  </template>
              </el-table-column> 
              <el-table-column prop="copy" label="复印件" width="60" >
                  <template slot-scope="scope">
                    <template v-if="scope.row.copy">✔</template>
                    <template v-else></template>
                  </template>
              </el-table-column> 
              <el-table-column prop="scan" label="扫描件" width="60" >
                  <template slot-scope="scope">
                    <template v-if="scope.row.scan">✔</template>
                    <template v-else></template>
                  </template>
              </el-table-column> 
              <el-table-column prop="electronic" label="电子版" width="60" >
                  <template slot-scope="scope">
                    <template v-if="scope.row.electronic">✔</template>
                    <template v-else></template>
                  </template>
              </el-table-column> 
              <el-table-column prop="fileTagNames" label="文件标签" :show-overflow-tooltip="true" width="250"></el-table-column>
              <el-table-column prop="trueName" label="创建人" width="80"></el-table-column>
              <el-table-column prop="created" label="创建时间" width="140"></el-table-column>
              <!-- <el-table-column fixed="right" label="操作" width="200"> -->
              <el-table-column label="操作" width="140" >
                  <template slot-scope="scope">
                      <el-button v-if="!isInstance" type="primary" size="mini" icon="el-icon-edit-outline" title="修改" circle @click="handleOpenFolder(scope.row)"></el-button>
                      <el-button v-if="isInstance&&scope.row.category===0" type="primary" size="mini" icon="el-icon-download" title="下载" circle @click="handleDownLoad(scope.row)"></el-button>
                      <el-tooltip content="默认只能删除自己创建的" placement="top" effect="light">
                          <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDelete(scope.row)"></el-button>
                      </el-tooltip>
                      <el-button v-if="isInstance&&scope.row.category===0" type="success" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row)"></el-button>
                  </template>
              </el-table-column>
          </el-table>
          <!-- <el-row type="flex" justify="end">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="totalPageNum"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  @current-change="queryFormData"
                  >
              </el-pagination>
          </el-row> -->
      </div>
       <el-dialog
            title="移动到"
            append-to-body
            :visible.sync="isShowDirectory">
            <el-form size="mini" label-width="120px">
               <el-row>
                  <el-col :span="12">
                      <el-form-item label="文件目录">
                         <!-- :data="businessTree" -->
                          <ArchiveTemplateTree
                              ref="treeChild"
                              :popover="true"
                              :templateId="templateId"
                              :processInstanceId="processInstanceId"
                              :isInstance="isInstance"
                              :defaultProps="{}"
                              @nodeClick="handleTreeNode"
                          />
                      </el-form-item>
                  </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowDirectory = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveMove">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
              custom-class="task-edit-dialog"
              :title="folderTitle"
              :visible.sync="isShowFolder"
              top="4vh"
              width="70%"
              append-to-body
              >
                <el-form size="mini" label-width="120px">
                    <el-row>
                        <el-form-item label="上级目录">
                          <el-input disabled="disabled" v-model="pDirectory"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="文件标签" >
                        <TreeSelect
                            v-if="isShowTagsTree"
                            ref="treeSelect" 
                            :sourceOptions="sourceOptions" 
                            :disableBranchNodes="false"
                            @treeSelectChoose="treeSelectChoose"
                            :multiple="true"  
                            :flat="true"
                        /> 
                      </el-form-item>
                   </el-row>
                    <el-row>
                        <el-form-item label="序号">
                          <el-input :disabled="isdisabled" v-model="folderObj.orderNum"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="文件夹名称">
                          <el-input :disabled="isdisabled" placeholder="文件夹名称" v-model="folderObj.label"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item :disabled="isdisabled" label="是否需要">
                            <el-radio v-model="folderObj.need" :label="true">应</el-radio>
                            <el-radio v-model="folderObj.need" :label="false">宜</el-radio>
                        </el-form-item>
                    </el-row>
                     <el-row >
                        <el-form-item label="资料形式">
                           <el-checkbox-group :disabled="isdisabled" v-model="checkboxSelected">
                             <el-checkbox v-for="obj in checkboxArr"  :key="obj.index" :label="obj.label" >{{obj.name}}</el-checkbox>
                           </el-checkbox-group> 
                        </el-form-item>
                    </el-row>
                    <el-form-item label="备注说明">
                        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="folderObj.remarks" />
                    </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowFolder = false">取 消</el-button>
                  <el-button type="primary" :loading="!isShowFolder" @click="handleAddFolder">保存</el-button>
              </span>
          </el-dialog>
          <el-dialog
              title="档案明细"
              width="80%"
              append-to-body
              :fullscreen=true
              :visible.sync="isShowPreview"
              >
              <div class='print-class'>
                  <el-button size="mini" icon="el-icon-printer" @click.stop="handlePrint()">打印</el-button>
                  <!--<el-button size="mini" icon="el-icon-printer" v-print="`#archiveDetail`">打印</el-button>-->
              </div>
              <tree-table 
                id = "archiveDetail"
                :ref="'archiveDetail'"
                :data="archiveTemplateTreeList" 
                :isShowBtn="isInstance" 
                :isShowCheckbox="false" 
                :expandAll="true" 
                :columns="archiveTemplateTreeColumns" 
                :templateId="templateId"
                :processInstanceId="processInstanceId"
                @manageFolder="manageFolder" 
                @getFileList="handleViewTemplate" 
                @handleDownLoad="handleDownLoad" 
                @previewFile="previewFile" 
                @handleDelete="handleDelete" 
                border/>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowPreview=false">取 消</el-button>
                </span>
          </el-dialog> 
    </div>
</template>

<script>
    import mixinsNav from '@/mixins/mixins-nav';
    import { API_FILE_DOWNLOAD } from '@/common/constants';
    import { copyCustomFormById, deleteFormConfig, updShareInner, addMoveArchiveFile, saveArchiveTemplateTreeNode, saveArchiveTemplateInstanceTree, getArchiveTemplateFiles, getArchiveTemplateTreeList, deleteArchiveTemplateFile, getArchiveTemplateInstanceFiles, getArchiveTemplateInstanceTreeList, downloadFiles, getFileTagsArchiveTemplateTreeList } from '@/data-model';
    import ProcessFiles from '@/pages/process/components/ProcessFiles';
    import TreeTable from '@/components/TreeTable';
    import { getGlobalConf, getPreviewFileUrl } from '@/utils/grocer';
    import { isEmpty } from 'lodash';
    import printJS from 'print-js';
    export default {
        mixins: [ mixinsNav ],
        components: {
            ProcessFiles,
            TreeTable
        },
        data () {
            return {
                loadTimer: '',
                nowPathKey: '', // 当前路径深度对应的key
                formList: [], // 列表数据
                currentPage: 1, // 当前页码
                pageSize: 20, // 每页条数
                totalPageNum: 1, // 总页数
                loading: false, // 列表的loading状态
                searchName: '', // 查询的关键字,
                isChooseFile: false,
                fileList: [],
                directoryList: [], // 文件夹目录导航栏
                treeId: '1', // 当前选中的树节点
                treeName: '456', // 当前选中的树节点名称
                selectTreeNode: {label: ''},
                // rootPath:'/document/archiveTemplate',
                fileListLength: 0,
                selectedCheckboxList: [],
                isShowDirectory: false,
                targetDirectoryId: '',
                targetDirectoryName: '',
                isShowFolder: false,
                isdisabled: false,
                isShowPreview: false,
                folderTitle: '',
                folderObj: {
                    id: '',
                    pId: '', // 上级节点
                    category: 1,
                    templateId: '', // 档案模板id
                    orderNum: '', // 序号
                    label: '', // 文件夹名称
                    remarks: '', // 备注说明
                    need: true, // 是否必须包含该类文件 0不必须  1必须
                    fileTypes: '', // 资料形式
                    original: false, // 原件
                    copy: false, // 复印件
                    scan: false, // 扫描件
                    electronic: false // 电子版
                },
                checkboxSelected: [],
                checkboxArr: [
                    {index: 1, label: '1', name: '原件'},
                    {index: 2, label: '2', name: '复印件'},
                    {index: 3, label: '3', name: '扫描件'},
                    {index: 4, label: '4', name: '电子版'}
                ],
                archiveTemplateTreeList: [],
                archiveTemplateTreeColumns: [
                    {
                        text: '序号',
                        value: 'orderNum',
                        width: 200
                    }, {
                        text: '名称',
                        value: 'label',
                        width: 200
                    }, {
                        text: '备注说明',
                        value: 'remarks',
                        width: 300
                    }, {
                        text: '是否需要',
                        value: 'isNeedView',
                        width: 70
                    },
                    {
                        text: '原件',
                        value: 'isOriginalView',
                        width: 60
                    }, {
                        text: '复印件',
                        value: 'isCopyView',
                        width: 60
                    }, {
                        text: '扫描件',
                        value: 'isScanView',
                        width: 60
                    }, {
                        text: '电子版',
                        value: 'isElectronicView',
                        width: 60
                    }
                    // ,{
                    // text: '上传人',
                    // value: 'uploadUser',
                    // width: 60
                    // },{
                    // text: '上传时间',
                    // value: 'uploadTime',
                    // width: 140
                    // }
                ],
                pDirectory: '', // 当前父目录
                isShowTagsTree: false,
                sourceOptions: [],
                selectTagIdsArr: [],
                selectTagNamesArr: []
            };
        },
        watch: {
            checkboxSelected (newVal, oldVal) {
                if (newVal) {
                    this.folderObj.original = false;
                    this.folderObj.copy = false;
                    this.folderObj.scan = false;
                    this.folderObj.electronic = false;
                    newVal.forEach(item => {
                        if (item === '1') {
                            this.folderObj.original = true;
                        } else if (item === '2') {
                            this.folderObj.copy = true;
                        } else if (item === '3') {
                            this.folderObj.scan = true;
                        } else if (item === '4') {
                            this.folderObj.electronic = true;
                        }
                    });
                }
            }
        },
        props: {
            isInstance: { // 是否为模板
                type: Boolean,
                default: false
            },
            templateId: { // 档案模板id
                type: String
            },
            processInstanceId: { // 流程实例id
                type: String
            },
            rootPath: { // 面包屑导航栏地址
                type: String,
                default: '/document/archiveTemplate'
            }
        },
        filters: {// 如下这样写
            getfilesize: function (size) {
                // console.log(size);
                if (!size) {
                    return '';
                }
                var num = 1024.00; // byte
                if (size < num) { return size + '(B)'; }
                if (size < Math.pow(num, 2)) { return (size / num).toFixed(2) + '(K)'; } // kb
                if (size < Math.pow(num, 3)) { return (size / Math.pow(num, 2)).toFixed(2) + '(M)'; } // M
                if (size < Math.pow(num, 4)) { return (size / Math.pow(num, 3)).toFixed(2) + '(G)'; } // G
                return (size / Math.pow(num, 4)).toFixed(2) + '(T)'; // T
            }
        },
        methods: {
            async _initPage () {
                await this.setBreadcrumb();
                await this._getFormData();
                this.initFolderObj();
            },
            initFolderObj () {
                this.folderObj = {
                    id: '',
                    pId: '', // 上级节点
                    category: 1,
                    templateId: this.templateId, // 档案模板id
                    orderNum: '', // 序号
                    label: '', // 文件夹名称
                    remarks: '', // 备注说明
                    need: true // 是否需要包含该类文件 0宜  1应
                };
            },
            async setBreadcrumb () {
                let treeList = [];
                if (this.isInstance) {
                    treeList = await getArchiveTemplateInstanceTreeList({templateId: this.templateId, processInstanceId: this.processInstanceId});
                } else {
                    treeList = await getArchiveTemplateTreeList({templateId: this.templateId});
                }
                let treeFileArr = [
                    {path: '', key: '-1', meta: {title: '档案模板'}},
                    {path: '', key: treeList[0].id, meta: { title: treeList[0].label }}
                ];
                this.treeId = treeList[0].id + '';
                this.directoryList = treeFileArr;
                this.archiveTemplateTreeList = treeList;
                // console.log(this.archiveTemplateTreeList);
            },
            handleBreadcrumb (obj, index) {
                // console.log(index);
                this.directoryList[index].path = '';
                this.treeId = obj.key + '';
                this.treeName = obj.meta.title;
                let temp = [];
                for (var i = 0; i < index + 1; i++) {
                    temp.push(this.directoryList[i]);
                }
                this.directoryList = temp;
                this._getFormData();
            },
            async handleOpenFolder (obj) {
                // console.log(obj);
                let pDirectory = '';
                for (var i = 0, len = this.directoryList.length; i < len; i++) {
                    pDirectory += this.directoryList[i].meta.title + ' > ';
                }
                pDirectory = pDirectory.substring(0, pDirectory.lastIndexOf(' > '));
                this.pDirectory = pDirectory;
                if (obj !== '') {
                    this.folderTitle = '修改文件夹';
                    this.folderObj.id = obj.id;
                    this.folderObj.pId = obj.pId;
                    this.folderObj.templateId = obj.templateId;
                    this.folderObj.orderNum = obj.orderNum;
                    this.folderObj.label = obj.fileName;
                    this.folderObj.remarks = obj.remarks;
                    this.folderObj.need = obj.need;
                    let selected = [];
                    if (obj.original) {
                        selected.push('1');
                    }
                    if (obj.copy) {
                        selected.push('2');
                    }
                    if (obj.scan) {
                        selected.push('3');
                    }
                    if (obj.electronic) {
                        selected.push('4');
                    }
                    this.checkboxSelected = selected;
                } else {
                    this.folderTitle = '新建文件夹';
                    this.checkboxSelected = [];
                    this.initFolderObj();
                }
                if (this.isInstance) {
                    this.isdisabled = true;
                }
                await this.initData(obj);
                this.isShowFolder = true;
            },
            handleAddFolder () { // 新建文件夹
                if (this.folderObj.label.trim() === '') {
                    this.$message({message: '请输入文件夹名称', type: 'warning'});
                    return;
                }
                this.folderObj.pId = this.treeId;
                this.folderObj.templateId = this.templateId;
                if (!isEmpty(this.selectTagIdsArr)) {
                    let selectTagIdsArrNew = [];
                    this.selectTagIdsArr.forEach(item => {
                        selectTagIdsArrNew.push(item.indexOf('-') !== -1 ? item.substring(item.indexOf('-') + 1) : item);
                    });
                    this.folderObj.fileTagIds = selectTagIdsArrNew.join(',');
                    this.folderObj.fileTagNames = this.selectTagNamesArr.join(',');
                }
                // console.log(this.folderObj);
                this.$confirm('您确定' + this.folderTitle + '吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (this.isInstance) {
                        await saveArchiveTemplateInstanceTree(this.folderObj);
                        this.handleViewTemplate();
                    } else {
                        await saveArchiveTemplateTreeNode(this.folderObj);
                        this._getFormData();
                    }
                    this.isShowFolder = false;
                }).catch(() => {});
            },
            manageFolder (row) {
                this.folderTitle = '修改档案目录';
                // console.log(row);
                this.folderObj.id = row.id;
                this.folderObj.pId = row.pId;
                this.pDirectory = row.pLabel;
                this.folderObj.templateId = row.templateId;
                this.folderObj.orderNum = row.orderNum;
                this.folderObj.label = row.label;
                this.folderObj.remarks = row.remarks;
                this.folderObj.need = row.need;
                let selected = [];
                if (row.original) {
                    selected.push('1');
                }
                if (row.copy) {
                    selected.push('2');
                }
                if (row.scan) {
                    selected.push('3');
                }
                if (row.electronic) {
                    selected.push('4');
                }
                this.checkboxSelected = selected;
                // console.log(this.isInstance);
                if (this.isInstance) {
                    this.isdisabled = true;
                }
                this.isShowFolder = true;
            },
            handleSelectionChange (val) { // 选择checkbox
                this.selectedCheckboxList = val;
                if (val && val.length > 0) {
                    this.isChooseFile = true;
                } else {
                    this.isChooseFile = false;
                }
            },
            async handleViewTemplate () {
                let treeList = [];
                if (this.isInstance) {
                    treeList = await getArchiveTemplateInstanceTreeList({templateId: this.templateId, processInstanceId: this.processInstanceId, hasChildFiles: true});
                } else {
                    treeList = await getArchiveTemplateTreeList({templateId: this.templateId});
                }
                this.archiveTemplateTreeList = treeList;
                this.isShowPreview = true;
            },
            handleShareOuter () { // 分享
                // console.log('handleShareOuter');
            },
            async handleShareInnerBatch (shareStatus) {
                if (this.selectedCheckboxList.length === 0) {
                    this.$message({message: '请选择要共享的文件', type: 'warning'});
                    return;
                }
                this.$confirm('您确定要批量共享文件吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // await deleteArchiveTemplateFile(delfileIds.join(','));
                    let shareObj = {
                        shareFiles: this.selectedCheckboxList,
                        shareStatus: shareStatus
                    };
                    await updShareInner(shareObj);
                    await this._getFormData();
                });
            },
            async handleShareInner (row, shareStatus) { // 共享
                let shareObj = {
                    shareFiles: [row],
                    shareStatus: shareStatus
                };
                await updShareInner(shareObj);
                await this._getFormData();
            },
            handleDownLoadBatch () { // 批量下载
                // console.log('handleDownLoadBatch');
            },
            handleDownLoad (row) { // 下载
                // console.log(row);
                if (row.filePath) {
                    let url = `${API_FILE_DOWNLOAD}${row.filePath}`;
                    this.download(url);
                }
            },
            download (url) {
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
                downloadFiles(url);
            },
            async previewFile (file) {
                let previewUrl = await getPreviewFileUrl(file);
                if (previewUrl) {
                    let tempwindow = window.open();
                    tempwindow.location = previewUrl;
                }
            },
            async handleDeleteBatch () { // 删除
                if (this.selectedCheckboxList.length === 0) {
                    this.$message({message: '请选择要删除的文件', type: 'warning'});
                    return;
                }
                // this.selectedCheckboxList.forEach(item => {
                //   delfileIds.push(item.id);
                // });
                // console.log(delfileIds.join(','));
                this.$confirm('您确定要批量删除文件吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let delObj = {
                        files: this.selectedCheckboxList
                    };
                    await deleteArchiveTemplateFile(delObj);
                    await this._getFormData();
                });
            },
            handleDelete (row) { // 删除
                this.$confirm('您确定要删除文件【' + row.fileName + '】吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // let delObj = {
                    //   files:[row]
                    // };
                    let delObj = {
                        files: [{id: row.id, category: row.category, templateId: row.templateId, createdBy: row.createdBy, approvalStatus: row.approvalStatus}]
                    };
                    await deleteArchiveTemplateFile(delObj);
                    await this._getFormData();
                });
            },
            handleRename () { // 重命名
                // console.log('handleRename');
            },
            handleCopy () { // 复制到
                // console.log('handleCopy');
            },
            handleMove () { // 移动到
                // console.log("handleMove");
                setTimeout(() => {
                    this.$refs.treeChild._initPage();
                }, 0);
                this.isShowDirectory = true;
            },
            async handleSaveMove () {
                // console.log(this.selectedCheckboxList);
                // console.log(this.targetDirectoryId);
                // console.log(this.targetDirectoryName);
                this.isShowDirectory = false;
                this.$confirm('您确定要批量移动文件吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let moveObj = {
                        targetDirectoryId: this.targetDirectoryId,
                        sourceFiles: this.selectedCheckboxList,
                        isInstance: this.isInstance
                    };
                    await addMoveArchiveFile(moveObj);
                    await this._getFormData();
                });
            },
            handlePreview () { // 预览文件
                // console.log('handlePreview');
            },
            handleEnterFolder (row) { // 进入文件夹
                let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                this.directoryList[this.directoryList.length - 1].path = ROUTER_BASE_PATH + this.rootPath;
                this.directoryList.push({path: '', key: row.id, meta: {title: row.fileName}});
                this.treeId = row.id + '';
                // console.log(this.directoryList);
                this._getFormData();
            },
            handleSetFile (params) {
                // let fileObjectKeys = ['name', 'fileName', 'fileByteSize', 'filePath'];
                let fileValues = [];
                try {
                    if (params && params.fileList) {
                        let fileLists = params.fileList;
                        fileLists.forEach(file => {
                            // console.log(file);
                            if (file.status && file.status === 'success') {
                                if (file.response && file.response.data) {
                                // 本次上传的文件
                                    let resDataList = file.response.data;
                                    resDataList.forEach(resFile => {
                                        fileValues.push(this.setFileInfo(resFile));
                                    });
                                } else {
                                    fileValues.push(this.setFileInfo(file));
                                }
                            } else {
                                // 以前上传完成，并保存的文件
                                fileValues.push(this.setFileInfo(file));
                            }
                        });
                    }
                    // console.log(fileValues);
                } catch (error) {
                    console.error(error);
                }
            },
            setFileInfo (obj) {
                return {
                    name: obj.fileName,
                    fileName: obj.fileName,
                    fileByteSize: obj.fileByteSize,
                    filePath: obj.filePath
                };
            },
            async _getFormData () {
                this.loading = true;
                let formData = {};
                if (this.isInstance) {
                    formData = await getArchiveTemplateInstanceFiles({
                        currentPage: this.currentPage,
                        pageSize: this.pageSize,
                        fileName: this.searchName,
                        treeId: this.treeId,
                        templateId: this.templateId,
                        processInstanceId: this.processInstanceId
                    });
                } else {
                    formData = await getArchiveTemplateFiles({
                        currentPage: this.currentPage,
                        pageSize: this.pageSize,
                        fileName: this.searchName,
                        treeId: this.treeId,
                        templateId: this.templateId
                    });
                }
                this.formList = formData.data;
                for (let i = 0; i < this.formList.length; i++) {
                    if (!isNaN(this.formList[i].orderNum)) {
                        this.formList[i].orderNum = this.formList[i].orderNum * 1;
                    }
                }
                this.loadTimer = new Date().getTime();
                this.fileListLength = formData.data.length;
                // this.currentPage = formData.currentPage;
                // this.pageSize = formData.pageSize;
                // this.totalPageNum = formData.totalPageNum;
                this.loading = false;
            },
            async _deleteFormData (id) {
                await deleteFormConfig(id);
            },
            queryFormData (currentPage) {
                this.currentPage = currentPage;
                this._getFormData();
            },
            handleTemplateDelete (id) {
                this.$confirm('您确定要删除此条模板吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await this._deleteFormData(id);
                    await this._getFormData();
                });
            },
            handleSearch () {
                this._getFormData();
            },
            async handleNavFormCopy (id) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = {};
                formData.formId = id;
                await copyCustomFormById(formData);
                loading.close();
                this._getFormData();
            },
            handleTreeNode (data, node, tree) {
                // console.log(data);
                this.targetDirectoryId = data.id;
                this.targetDirectoryName = data.label;
            },
            handlePrint () {
                // let printObj = [this.$refs['archiveDetail']];
                // this.$print(printObj);

                printJS({
                    printable: 'archiveDetail', // 要打印内容的id
                    type: 'html',
                    // style: style,
                    // scanStyles: false,
                    targetStyles: ['*']// 继承原来的所有样式
                });
            },
            getOrderNum (row, column) {
                // console.log(orderNum);
                if (!Number.isNaN(row.orderNum)) {
                    let transNum = parseInt(row.orderNum);
                    // console.log(transNum);
                    if (Number.isNaN(transNum)) {
                        return transNum;
                    } else {
                        return row.orderNum;
                    }
                } else {
                    return row.orderNum;
                }
            },
            treeSelectChoose (selected) { // 选择好数据源后
                // console.log(selected);
                if (selected && selected.length > 0 && selected[0] === undefined) {
                    return;
                }
                this.selectTagIdsArr = [];
                this.selectTagNamesArr = [];
                selected.forEach(item => {
                    this.selectTagIdsArr.push(item.id.substring(item.id.indexOf('-') + 1));
                    this.selectTagNamesArr.push(item.label);
                });
            // let tempTags = [];
            // this.searchFileParams.selectTags = tempTags.join(',');
            },
            async initData (obj) {
                this.selectTagIdsArr = [];
                this.selectTagNamesArr = [];
                if (obj.fileTagIds) {
                    let selectTagIdsArrTemp = obj.fileTagIds.split(',');
                    this.selectTagNamesArr = obj.fileTagNames.split(',');
                    selectTagIdsArrTemp.forEach(item => {
                        this.selectTagIdsArr.push('0-' + item);
                    });
                }
                await this.getTagsList();
                setTimeout(() => {
                    this.$refs.treeSelect.initParam(this.selectTagIdsArr);
                }, 0);
            },
            async getTagsList () {
                let tags = await getFileTagsArchiveTemplateTreeList({flg: '0', templateId: this.templateId, processInstanceId: this.processInstanceId});
                this.isShowTagsTree = true;
                this.sourceOptions = [];
                if (tags) {
                    this.sourceOptions = tags;
                }
            }
        }
    };
</script>

<style lang="less">
.archive-template{
    a{color:#606266}
    a:link {
      color:#606266;
      text-decoration:none;
    }
    a:hover{
      color:#09AAFF;
      text-decoration:none;
    }
    .tools-bar{
          margin: 5px;
    }
    .archiveTemplate {
        margin-top: 5px;
        margin-left: 10px;
        margin-bottom: 5px;
        background: #fff;
    }
    .form-list {
        width: 100%;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }
    .show-file-info{
      margin-right: 20px;
      float: right;
      font-size: 12px;
      color: rgb(102, 102, 102);
      font: "12px/1.5 "Microsoft YaHei", arial, SimSun, 宋体;"
    }
    .tools-btn-group{
      margin-top: 1px;
      float: right;
    }
    .print-class {
        float: right;
        & > .el-button {
            margin-right: 10px;
        }
    }
}
    
</style>




// WEBPACK FOOTER //
// src/components/ArchiveTemplate/ArchiveTemplate.vue